import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=48fb58b8&scoped=true&"
import script from "./Relations.vue?vue&type=script&lang=js&"
export * from "./Relations.vue?vue&type=script&lang=js&"
import style0 from "./Relations.vue?vue&type=style&index=0&id=48fb58b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fb58b8",
  null
  
)

export default component.exports